<template>
  <div class="agreement_page">
    <div class="agreement_title">{{info.title}}</div>
    <div class="agreement_content" v-html="info.content"></div>
  </div>
</template>
<script>
  import content from '../../../api/content';
  export default {
    data () {
      return {
        info:'',
      }
    },
    created () {
      this.$store.commit('param/show', false)

      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
      this.getAgreement(11)
    },
    methods: {
      getAgreement(id){
        content.getAgreement({id:id}).then(res => {
          this.info=res.data.data
        })
      },
    }
  };
</script>

<style lang="scss">
  .agreement_page {
    padding: 10px;
  }
</style>
